module.exports = __webpack_public_path__ + "static/media/alert2.da6b9470.svg";